module.exports = __webpack_public_path__ + "img/white.ca8a7156.jpg";